import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OpportunityState {
  opportunityNumber: string | null;
}

const initialState: OpportunityState = {
  opportunityNumber: null,
};

const customerDataSlice = createSlice({
  name: "customerData",
  initialState,
  reducers: {
    setOpportunityNumber: (state, action: PayloadAction<string>) => {
      state.opportunityNumber = action.payload;
    },
    clearOpportunityNumber: (state) => {
      state.opportunityNumber = null;
    },
  },
});

export const { setOpportunityNumber, clearOpportunityNumber } = customerDataSlice.actions;
export default customerDataSlice.reducer;
